import React from "react";

const PillButton = ({
  href,
  variant = "solid",
  children,
  className = "",
  onClick,
  type = "button",
  disabled = false,
  dataTestId,
}) => {
  const handleMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--ox", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--oy", `${e.clientY - r.top}px`);
  };

  const base =
    "group relative inline-flex items-center justify-center overflow-hidden rounded-full uppercase whitespace-nowrap cursor-pointer select-none isolate border border-ink px-8 py-[9px] text-[15px] sm:text-[16px] tracking-[0.08em] leading-[25.6px] font-display transition-colors duration-500";
  const tone =
    variant === "solid"
      ? "bg-ink text-linen group-hover:text-ink"
      : "bg-transparent text-ink group-hover:text-linen";
  const cls = `${base} ${tone} ${disabled ? "cursor-not-allowed" : ""} ${className}`;

  const inner = (
    <>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background: variant === "solid" ? "var(--color-linen)" : "var(--color-ink)",
          clipPath: "circle(0% at var(--ox, 50%) var(--oy, 50%))",
          transition: "clip-path 650ms cubic-bezier(0.22, 1, 0.36, 1)",
        }}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{
          background:
            variant === "solid"
              ? "radial-gradient(80px circle at var(--ox,50%) var(--oy,50%), rgba(8,9,10,0.10), transparent 65%)"
              : "radial-gradient(80px circle at var(--ox,50%) var(--oy,50%), rgba(245,233,224,0.22), transparent 65%)",
        }}
      />
      <span
        aria-hidden="true"
        className="shine-sweep pointer-events-none absolute inset-y-0 left-0 w-1/2 bg-gradient-to-r from-transparent via-white/45 to-transparent"
      />
      <span className="relative z-10 inline-block overflow-hidden">
        <span className="block transition-transform duration-[520ms] group-hover:-translate-y-full" style={{ transitionTimingFunction: "cubic-bezier(0.22,1,0.36,1)" }}>
          {children}
        </span>
        <span
          aria-hidden="true"
          className="absolute inset-0 block translate-y-[110%] transition-transform duration-[520ms] group-hover:translate-y-0"
          style={{ transitionTimingFunction: "cubic-bezier(0.22,1,0.36,1)" }}
        >
          {children}
        </span>
      </span>
    </>
  );

  if (disabled) {
    return (
      <span role="button" data-testid={dataTestId} title={typeof disabled === "string" ? disabled : undefined} className={`${cls} cursor-not-allowed opacity-80`} onClick={onClick}>
        {inner}
      </span>
    );
  }
  if (href) {
    return (
      <a href={href} data-testid={dataTestId} className={cls} onMouseMove={handleMove} onClick={onClick}>
        {inner}
      </a>
    );
  }
  return (
    <button type={type} data-testid={dataTestId} className={cls} onMouseMove={handleMove} onClick={onClick}>
      {inner}
    </button>
  );
};

export default PillButton;
